export default __webpack_public_path__ + "static/media/Latest Releases.c599c931.svg";